<template>

  <div>
    <!-- Carosel Items -->
    <v-carousel cycle
                show-arrows-on-hover
                hide-delimiter-background
                interval='20000'
                transition="fade-transition">
      <v-carousel-item v-for="(carousel, i) in carousel"
                       :key="i">
        <v-sheet :color="carousel.colors"
                 height="100%"
                 tile>
          <v-row class="fill-height pa-5"
                 align="center"
                 justify="center">
            <v-col
              :md='4'
              :sm='10'
            >
              <div class="display-2 hidden-sm-and-down">{{ carousel.header }}</div>
              <div class="display-1 hidden-md-and-up">{{ carousel.header }}</div>
              <span class="white--text title hidden-sm-and-down">  {{ carousel.text }} </span>
              <span class="white--text subtitle-1 hidden-md-and-up">  {{ carousel.text }} </span>
              <br/>  <br/>
              <center>
              <v-btn color="success" target='_blank' href="https://calendly.com/productionboard/production-board-demo?back=1&month=2022-10">Schedule Demo</v-btn>
              </center>
            </v-col>
            <v-col :md='5' :sm='10' class='hidden-sm-and-down'>
              <v-img class='contain, elevation-10' :src='carousel.imgsrc' />
            </v-col>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
    <!-- end carosel slides -->

    <!-- What is pboard section -->
      <v-row class="fill-height pt-5 pb-5 grey lighten-5"
             align="center"
             justify="center">
        <v-col
          md=5
          sm=12
          class='hidden-sm-and-down'

        >
          <v-img class='contain' style="border-radius: 5px" src='img/boardmove.png' />
        </v-col>
        <v-col sm=12 md=4 class='title'>
          <blockquote class="blockquote text-left">
            <div class='display-2 primary--text'>Production Board</div>
            <div class='display-1'>What is it?</div>
            A cloud-based scheduling, workflow and communications tool built to help collision repair shops create, maintain, and improve a process centered environment.
            This system empowers you to measure every aspect of your production process allowing you
            to improve performance. Visual alerts keep you and your staff informed creating visibility and accountability shop-wide.

          </blockquote>
        </v-col>
      </v-row>

      <!-- First Feature-->
      <v-row
        no-gutters
        align="center"
        justify="center"
        class='pt-5 pb-5'
      >
        <v-col
          cols='10'

        >

          <v-row
            align="center"
            justify="center"
          >
            <v-col
              v-for='(iconfeat, i) in iconfeat'
              :key='i'
              cols='10'
              :md='3'
              :sm='12'
              align="center"
              justify="center"

              >
              <!--  icon -->
              <v-row
              no-gutters
              align="center"
              justify="center"
              >
                <v-col
                class='pa-2'
                  :sm='12'
                >
                  <v-img :src='iconfeat.img' max-height="80" max-width="80" contain />
                </v-col>
              </v-row>
              <v-row
              no-gutters
              align="center"
              justify="center"
              >
                <v-col
                  :sm='12'
                >
                  <div class='title'>{{ iconfeat.title }}</div>
                  <div class='blockquote'>{{ iconfeat.text }}</div>
                </v-col>
              </v-row>
              <!-- end  icon -->
            </v-col>
          </v-row>
    </v-col>
  </v-row>
      <!-- END First Row Feature -->

<v-parallax src="img/boardmove.png"></v-parallax>
      <v-row class="fill-height"
             align="center"
             justify="center">

        <v-col class='title' :md='5' :xs='10'>
          <blockquote class="blockquote text-left">
            <div class='display-2 primary--text'>Visualize</div>
            <div class='display-1'>Production Management</div>
            Lead focused production meetings with your team filtering down to your work in process. Visual cues signal priorities, opportunities and bottlenecks empowering you and your
            staff to take action. Custom job badges allow you to turn any aspect of production into a visual alert. With everyone having access to Production Board you keep an active, real time eye on your
            production ensuring everyone is on the same page.
          </blockquote>
        </v-col>
        <v-col class='hidden-sm-and-down' :md='4' :xs='2'>
          <v-img class='contain' style="border-radius: 5px" src='img/prodmeeting.png' />
        </v-col>
      </v-row>

      <v-row class="fill-height"
             align="center"
             justify="center">
        <v-col class='hidden-sm-and-down'
                :md='4'
                :sm='2'
        >
          <v-img class='contain' style="border-radius: 5px" src='img/dashboard.png' />
        </v-col>
        <v-col class='title' :md='5' :xs='10'>
          <blockquote class="blockquote text-left">
            <div class='display-2 primary--text'>Measure</div>
            <div class='display-1'>Insightful Reporting</div>

            The data collected with Production Board provides powerful insights into your production process. From simple reporting on incoming
            and outgoing lists to forecasting monthly outcomes and keeping an eye on department cycle times. Utilizing these
            tools a shop can identify priorities, opportunities and prevent potential bottlenecks in the production process.
          </blockquote>
        </v-col>
      </v-row>

      <v-row class="fill-height"
             align="center"
             justify="center">

        <v-col class='title' :md='5' :xs='10'>
          <blockquote class="blockquote text-left">
            <div class='display-2 primary--text'>Communicate</div>
            <div class='display-1'>Engage Messaging Platform</div>
            Customers today are utilizing their mobile phones more than ever to find information, shop and communicate. Text messaging is direct to your customer, cost-effective and
            simple to utilize. Automated personalized customer status update messages keep your customer informed throughout the process. Internal notification texts alert staff to critical items. Communicate openly
            with 2-way communication with image support with Production Board Pro.
          </blockquote>
        </v-col>
        <v-col class='hidden-sm-and-down' :md='4'>
          <v-img contain style="border-radius: 5px" src='img/messaging.png' />
        </v-col>
      </v-row>

  </div>

</template>

<script>

  export default {
    data() {
      return {
        carousel: [
          {
            colors: 'orange lighten-1',
            header: 'Scheduling',
            imgsrc: 'img/schedule.png',
            text: 'Job Class Scheduling is the practice of classifying jobs by the amount of work required for the purpose of improving quality and cycle time. Benefits of this practice are consistent workflow, increased billable hours, improved cycle times, predictable throughput, reduced bottlenecks, increased productivity and efficiency.'
          },
          {
            colors: 'blue lighten-1',
            header: 'Workflow',
            imgsrc: 'img/boardmove.png',
            text: 'Simple production workflow that is customizable to meet your existing production process. Gain valuable insight through the power of movement. Visual cues singal priorities, opportunities and bottlenecks proactively alerting you and your staff to critical production activies.'
          },
          {
            colors: 'green lighten-1',
            header: 'Communication',
            imgsrc: 'img/messaging.png',
            text:
              'Production Board is powered by the Engage Messaging Platform which sends automated status updates, custom texts and critical internal notifications.'
          },
          {
            colors: 'red lighten-1',
            header: 'Reporting',
            imgsrc: 'img/dashboard.png',
            text:
              'Automated data collection provides powerful insights into your business. Dozens of charts and reports keep you informed of schedules, cycle time trends, efficiencies, forecasts and much more.'
          },
        ],
        feature: [
          {
            title: 'Media Management',
            text: 'Save images, pdfs and other files to your job folder order easily keeping organized.',
            img: 'img/card/organization.jpg'
          },
          {
            title: 'Text Messaging',
            text: 'Send automatic status updates to your customer texts have a 99% open rate!',
            img: 'img/card/texting.jpg'
          },
          {
            title: 'Workflow Scheduling',
            text: 'Send automatic status updates to your customer texts have a 99% open rate!',
            img: 'img/card/texting.jpg'
          },
          {
            title: 'Mobile Access',
            text: 'With the power of the internet you can access your Production Board from anywhere with any device!',
            img: 'img/card/global.jpg'
          }
        ],
        iconfeat: [
          {
            img: 'img/icons/scheduling.svg',
            title: 'Efficient Scheduling',
            text: 'Schedule the right mix of work to maximize throughput with customizable job classes.'
          },
          {
            img: 'img/icons/cycle.svg',
            title: 'Kanban Style Interface',
            text: 'View all of your jobs in an easy-to-understand interface.'
          },
          {
            img: 'img/icons/flash.svg',
            title: 'Flashing Visual Indicators',
            text: 'Quickly determine which jobs need your attention and take action.'
          },
          {
            img: 'img/icons/mobile.svg',
            title: 'Automated Text Updates',
            text: 'Keep connected with your customers with status update text messaging.'
          },
          {
            img: 'img/icons/reporting.svg',
            title: 'Powerful Reporting',
            text: 'Our visual reporting makes it easy to see where your business is at and how you can improve.'
          },
          {
            img: 'img/icons/media.svg',
            title: 'Digital Media Management',
            text: 'Conveniently stores photos, scans, PDFs, and more directly into your Job Folder.'
          },
          {
            img: 'img/icons/cycle.svg',
            title: 'Critical Cycle Goal Alerts',
            text: '"Real-time" department cycle times trigger alerts to help identify opportunities to improve.'
          },
          {
            img: 'img/icons/workflow.svg',
            title: 'Streamline Workflow',
            text: 'Easily identify opportunities to minimize bottlenecks and produce a predictable delivery result.'
          },
        ]
      }
    }
  }

</script>
